async function CustomFetch(host, path, body, headers = {}) {
  const fetch = require('fetch-retry')(global.fetch)
  const url = `${host}/${path}`;
  const options = {
    retries: 3,
    retryDelay: 500,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify(body),
  };
  const res = await fetch(url, options);
  const data = await res.json();
  if (res.ok) {
    return data;
  } else {
    throw Error(data);
  }
}

export default CustomFetch;
